import styled from "styled-components/macro";

export const StyledProTipTop = styled.div`
  height: 50px;
  div {
    width: 25%;
    float: left;
    border-radius: 50%;
    background: var(--primary-cta);
    margin-top: 22px;
    height: 55px;
  }
`;

export const StyledProTipBottom = styled.div`
  height: 55px;
  div {
    width: 25%;
    float: left;
    border-radius: 50%;
    background: var(--primary-cta);
    margin-top: -28px;
    height: 55px;
  }
  clear: both;
`;

export const StyledProTipMiddle = styled.div`
  background: var(--primary-cta);
  padding: 15px;
  padding-bottom: 60px;
  color: white;
  position: relative;

  h3 {
    color: white !important;
  }

  .bf-button {
    position: absolute;
    bottom: 10px;
    right: 15px;
    background: none;
    border: 2px solid white;
    color: white;
    padding: 4px 14px;
    font-size: 14px;
    font-weight: 500;
    font-family: "Inter";
    cursor: pointer;
    border-radius: 6px;

    &:hover {
      background: var(--primary-cta-hover);
    }

    &:focus-visible {
      outline: 2px solid white;
      outline-offset: 2px;
    }
  }

  img {
    width: 20px;
    color: white;
  }
`;

export const StyledHand = styled.div`
  position: absolute;
  left: ${({ position }) => (position === "right" ? "230px" : "-20px")};
  transform: rotateY(${({ position }) => (position === "right" ? "0deg" : "180deg")});
  top: 75px;
  z-index: 999;
  path#hand-highlight {
    fill: var(--primary-cta);
  }

  ${({ position }) => (position === "up" || position === "up-right" ? "transform: rotate(-90deg);" : "")}
  ${({ position }) => (position === "up" ? "left: 16px;" : "")}
  ${({ position }) => (position === "up-right" ? "left: 198px;" : "")}

  ${({ position }) => (position === "up" || position === "up-right" ? "top: 8px;" : "")}
`;

export const StyledProTip = styled.div`
  width: 240px;
  position: absolute;
  line-height: 21px;
  top: ${({ top }) => top && top + "px"};
  left: ${({ left }) => left && left + "px"};
  padding-bottom: 30px;
  z-index: 999;
`;
